
import Download from '~/components/type/Download'
import Collect from '~/components/type/Collect'
import { openUrl } from '~/plugins/util'
export default {
    props: {
        list: { type: Array, default: () => [] },
    },
    components: { Download, Collect },
    data() {
        return {
        };
    },
    computed: {
    },
    created() {
    },
    methods: {
        toDetail(item) {
            openUrl(this.$router, {
                 path: "/material/detail",
                query: {
                    from: 'book',
                    id: item.id || ''
                }
            })
        },
        toDownload(item) {
            if(parseFloat(item.price)) return this.toDetail(item);
            // 下载接口
        }
    }
};
